import Common from '../wp-controlers/common-panel/geralAttributes';

export default {
  title: {
    type: 'string',
    default:
      'Você pode escolher perder horas no telefone. Ou ter a solução em até 24h.',
  },
  text: {
    type: 'string',
    default:
      'Os reparos da internet Sumicity são feitos nesse prazo. E isso é só o começo.',
  },
  ...Common,
};
